
import React, { useState } from 'react';

const GallerySection: React.FC = () => {
  const [activeTab, setActiveTab] = useState('youtube');

  const youtubeVideos = [
    {
      id: 'tvVRgQu0yT0',
      title: 'Turismo médico & Urología. Parte II',
      thumbnail: 'https://i.ytimg.com/vi/tvVRgQu0yT0/oardefault.jpg',
      views: '546 visualizaciones'
    },
    {
      id: 'EdAKp7MwKnw',
      title: 'Varicocele (várices escrotales) reparación Microquirúrgica',
      thumbnail: 'https://i.ytimg.com/vi/EdAKp7MwKnw/oardefault.jpg',
      views: '192 visualizaciones'
    },
    {
      id: 'R0lxrVqfZIM',
      title: 'Cirugía robótica por Cáncer de Próstata',
      thumbnail: 'https://i.ytimg.com/vi/R0lxrVqfZIM/oar2.jpg',
      views: '14 visualizaciones'
    },
    {
      id: '5RSk-9ER58A',
      title: 'Cirugía robótica y Turismo médico! Part.1',
      thumbnail: 'https://i.ytimg.com/vi/5RSk-9ER58A/oardefault.jpg',
      views: '127 visualizaciones'
    },
    {
      id: 'C8tm0ii0TOo',
      title: 'Síntomas de Crecimiento prostático',
      thumbnail: 'https://i.ytimg.com/vi/C8tm0ii0TOo/oar2.jpg',
      views: '172 visualizaciones'
    },
    {
      id: 'e6N0K_9N5S4',
      title: '¿Cirugía de mínima invasión en Urología?',
      thumbnail: 'https://i.ytimg.com/vi/e6N0K_9N5S4/oar2.jpg',
      views: '1.9K visualizaciones'
    },
    {
      id: 'GDjlK_FZ7o0',
      title: 'Tu urólogo de confianza!',
      thumbnail: 'https://i.ytimg.com/vi/GDjlK_FZ7o0/oardefault.jpg',
      views: '317 visualizaciones'
    },
    {
      id: '2uCMZieSEFM',
      title: '¿Todos los tumores son cáncer?',
      thumbnail: 'https://i.ytimg.com/vi/2uCMZieSEFM/oar2.jpg',
      views: '1.1K visualizaciones'
    },
    {
      id: '1Jm0od713IU',
      title: 'Cálculos Renales o Piedras en los riñones',
      thumbnail: 'https://i.ytimg.com/vi/1Jm0od713IU/oar2.jpg',
      views: '255 visualizaciones'
    },
    {
      id: 'jRRKylNKxzo',
      title: 'Cirugía robótica...Conociendo a DaVinci!',
      thumbnail: 'https://i.ytimg.com/vi/jRRKylNKxzo/oar2.jpg',
      views: '1K visualizaciones'
    },
    {
      id: 'DRLCCUSOFow',
      title: '¿Papiloma Humano en el hombre? Mitos & Realidades',
      thumbnail: 'https://i.ytimg.com/vi/DRLCCUSOFow/oardefault.jpg',
      views: '19K visualizaciones'
    },
    {
      id: 'GjwO9IfPkvU',
      title: '¿Cómo se opera un riñón actualmente?',
      thumbnail: 'https://i.ytimg.com/vi/GjwO9IfPkvU/oardefault.jpg',
      views: '2.1K visualizaciones'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Canal Educativo de YouTube</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Contenido educativo sobre cirugía robótica, urología y tratamientos médicos especializados del Dr. Héctor Remess.
          </p>
        </div>

        <div className="text-center mb-8">
          <div className="inline-flex items-center bg-red-50 rounded-full px-6 py-3 mb-4">
            <i className="ri-youtube-fill text-red-600 text-2xl mr-3"></i>
            <span className="text-red-800 font-semibold">Dr. Hector Remess - Tú Urólogo de Confianza</span>
          </div>
          <p className="text-gray-600">109 suscriptores • 15 videos • Contenido educativo especializado</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {youtubeVideos.map((video) => (
            <div
              key={video.id}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
              onClick={() => window.open(`https://www.youtube.com/watch?v=${video.id}`, '_blank')}
            >
              <div className="relative h-48">
                <img
                  alt={video.title}
                  className="w-full h-full object-cover object-center"
                  src={video.thumbnail}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center">
                    <i className="ri-play-fill text-white text-2xl ml-1"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-gray-900 mb-2 line-clamp-2 leading-tight">
                  {video.title}
                </h3>
                <div className="flex items-center text-xs text-gray-500">
                  <i className="ri-play-circle-line mr-1"></i>
                  <span>{video.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://www.youtube.com/@HectorRemess"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-red-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-youtube-line text-xl mr-2"></i>
            Suscríbete a Nuestro Canal
          </a>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
